import React, { useEffect, useRef } from 'react';
import { getReferenceFileTypeLabel } from '../../utils/referenceMaterialFormat';
import { libraryMaterialDisplayName } from '../../utils/saenggibuLibraryPick';
import './SaenggibuAttachMenu.css';

// 자료함 관리 화면 (chat ReferenceMaterialPicker.MATERIALS_SETTINGS_PATH 와 같은 경로; 라우터 의존을 피해 상수만 둔다)
export const MATERIALS_SETTINGS_PATH = '/chat/settings#materials';

const describe = (material) => {
  const parts = [];
  if (material.kind === 'file') {
    const typeLabel = getReferenceFileTypeLabel(material);
    if (typeLabel) parts.push(typeLabel);
  } else {
    parts.push('텍스트');
  }
  if (material.char_count) parts.push(`${Number(material.char_count).toLocaleString()}자`);
  return parts.join(' · ');
};

const ITEM_SELECTOR = 'button.sg-libpick-item';

/**
 * 자료함 자료 목록(표시 전용). 서버가 계획서류(plan_like) 먼저 정렬해 준 순서를 그대로 그린다.
 * - 열리면 첫 항목에 포커스, ↑/↓/Home/End 로 이동. 고르면 onPick(material) 한 번.
 * - 모달이 아니다. 닫기(Esc·바깥 클릭)는 부모(SaenggibuAttachMenu)가 처리한다.
 */
const SaenggibuLibraryMaterialList = ({ id, materials = [], onPick, onNavigate, autoFocus = true }) => {
  const listRef = useRef(null);

  useEffect(() => {
    if (!autoFocus) return;
    listRef.current?.querySelector(ITEM_SELECTOR)?.focus();
  }, [autoFocus]);

  const handleKeyDown = (event) => {
    const keys = ['ArrowDown', 'ArrowUp', 'Home', 'End'];
    if (!keys.includes(event.key)) return;
    const items = Array.from(listRef.current?.querySelectorAll(ITEM_SELECTOR) || []);
    if (items.length === 0) return;
    event.preventDefault();
    const index = items.indexOf(document.activeElement);
    let next = 0;
    if (event.key === 'ArrowDown') next = index < 0 ? 0 : (index + 1) % items.length;
    else if (event.key === 'ArrowUp') next = index < 0 ? items.length - 1 : (index - 1 + items.length) % items.length;
    else if (event.key === 'End') next = items.length - 1;
    items[next].focus();
  };

  return (
    <div id={id} className="sg-libpick-panel" role="group" aria-label="자료함">
      <ul ref={listRef} className="sg-libpick-list" aria-label="자료함 자료 목록" onKeyDown={handleKeyDown}>
        {materials.map((material) => (
          <li key={material.id}>
            <button
              type="button"
              className={`sg-libpick-item${material.plan_like ? ' is-plan' : ''}`}
              onClick={(event) => {
                event.stopPropagation();
                onPick?.(material);
              }}
            >
              <span className="sg-libpick-item-title">{material.title || libraryMaterialDisplayName(material)}</span>
              <span className="sg-libpick-item-meta">
                {material.source_filename && material.source_filename !== material.title
                  ? `${material.source_filename} · ${describe(material)}`
                  : describe(material)}
              </span>
            </button>
          </li>
        ))}
      </ul>
      {/* 폼 안 인라인 목록이라 라우터 의존 없이 일반 링크로 둔다 (같은 앱 경로) */}
      <a className="sg-libpick-manage" href={MATERIALS_SETTINGS_PATH} onClick={() => onNavigate?.()}>
        자료함 관리
      </a>
    </div>
  );
};

export default SaenggibuLibraryMaterialList;
